/**
 * TAKT. wordmark. "TAKT" in white, "." in orange (#FF6A00).
 * Used in nav, sidebar, login, and any branded surface.
 *
 * Bold, clean typography only — no icons, no decorations, no gradients,
 * no shadows. The orange period is the sole brand accent.
 */
export function Logo({ size = "md", tagline = "AI Estimator", className = "" }) {
  const sizes = {
    xs: "text-sm",
    sm: "text-base",
    md: "text-xl",
    lg: "text-3xl",
    xl: "text-5xl",
  };
  return (
    <div className={`leading-none ${className}`} data-testid="brand-logo">
      <div
        className={`font-black tracking-tight ${sizes[size]}`}
        style={{
          fontFamily: "Chivo, sans-serif",
          letterSpacing: "-0.04em",
        }}
      >
        <span className="text-white">TAKT</span>
        <span className="text-[#FF6A00]">.</span>
      </div>
      {tagline && (
        <div className="mt-1 text-[10px] tracking-[0.28em] uppercase text-slate-500 font-medium">
          {tagline}
        </div>
      )}
    </div>
  );
}

export default Logo;
